<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>

	<form @submit.prevent="onSubmit">

		<smart-input required :errors="inputErrors.price" label='מחיר' type="number" v-model="form.price"></smart-input>
		<smart-input required :errors="inputErrors.num_of_payments" min="1" label='מספר תשלומים' type="number" v-model="form.num_of_payments"></smart-input>
		<smart-input required :errors="inputErrors.amount" label='כמות כרטיׁׁסים' type="number"
			v-model="form.amount"></smart-input>
		<smart-input required :errors="inputErrors.title" label='כותרת' v-model="form.title"></smart-input>
		<smart-input textarea :errors="inputErrors.subtitle" label='תת כותרת' v-model="form.subtitle"></smart-input>
		<smart-input textarea :errors="inputErrors.thanks_words" label='מילות תודה' v-model="form.thanks_words"></smart-input>
		<v-btn type="submit" :loading="inProgress" color="success">שמירה</v-btn>
	</form>
</template>


<script>
	import PackageModule from "src/store/modules/Package.module";
	import FormView from "src/mixins/FormView";

	export default {
		props: [],
		mixins: [new FormView(PackageModule, "package")],
		name: "package-form",
		components: {},
		data() {
			return {
				form: {
					name: null,
				},
			};
		},
		computed: {
			isNew() {
				return !this.package.id;
			}
		}
	};
</script>
